<section class="activity">
    <div class="activity-header">
        <h2>
            <i class="pi pi-bolt p-mr-1"></i> <span class="p-mr-1">Activity</span>
        </h2>
        <p-badge [value]="totalComments$ | async" />
    </div>

    <main>
        <app-job-add-comment></app-job-add-comment>

        <!-- Custom timeline structure using divs and ngFor -->
        <div class="timeline">
            <div
                *ngFor="let comment of comments$ | async; trackBy: identifyComment; let last = last"
                class="timeline-event"
            >
                <!-- This div represents the vertical line and the marker -->
                <div class="timeline-event-separator">
                    <span
                        class="timeline-event-marker"
                        [pTooltip]="'Mode: ' + comment?.mode?.name || 'Comment'"
                    >
                        <!-- Render icon if available, otherwise a default bullet point -->
                        <i [class]="comment?.mode?.icon || 'pi pi-circle-fill'"></i>
                    </span>
                    <!-- The connector line, not rendered for the last item -->
                    <div
                        class="timeline-event-connector"
                        *ngIf="!last"
                    ></div>
                </div>

                <!-- This div holds the comment content -->
                <div class="timeline-event-content">
                    <app-job-comment
                        class="comment"
                        [class.system]="comment?.mode?.system || !comment?.author"
                        [class.topLevel]="true"
                        [comment]="comment"
                        [job]="job$ | async"
                    >
                    </app-job-comment>
                </div>
            </div>
        </div>
    </main>
</section>